var _path, _circle, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmptyProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 40,
    viewBox: "0 0 64 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8106 12.1768C24.8106 11.4392 24.2126 10.8412 23.475 10.8412H17.4043C16.6667 10.8412 16.0687 11.4392 16.0687 12.1768V12.1768C16.0687 12.9144 16.6667 13.5124 17.4043 13.5124H23.475C24.2126 13.5124 24.8106 12.9144 24.8106 12.1768V12.1768ZM26.0974 18.7925C26.0974 17.2503 24.8472 16 23.3049 16H7.52102C5.57641 16 4 17.5764 4 19.521V19.521C4 21.4656 5.57641 23.042 7.52102 23.042H11.1634C12.4375 23.042 13.4703 24.0749 13.4703 25.3489V25.3489C13.4703 26.623 14.5031 27.6558 15.7772 27.6558H29.3756C31.052 27.6558 32.411 26.2968 32.411 24.6204V24.6204C32.411 22.944 31.052 21.5851 29.3756 21.5851H28.89C27.3477 21.5851 26.0974 20.3348 26.0974 18.7925V18.7925ZM44 26C44 24.3431 45.3431 23 47 23H53C54.6569 23 56 24.3431 56 26V26C56 27.6569 54.6569 29 53 29H47C45.3431 29 44 27.6569 44 26V26Z",
    fill: "#CBD5E0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 8.5,
    r: 3.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 35.0001C26.4073 33.8525 42.8023 33.6313 60 34.6579",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8824 30.8894L17 34H44L41 27.4332C40.4118 25.5899 38.5 22.5 38.5 22.5L36 18C36 18 33.5 14 31 12.5C28.2601 10.8561 28.1673 12.8327 26.5 14.5C24.5 16.5 22.5 20 22.5 20L20.5 24L18.9412 27.4332C18.9412 27.4332 18.1176 30.0254 17.8824 30.8894Z",
    fill: "white",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8666 32.8827L25.6267 30.0864C25.8294 29.3097 26.5389 26.9794 26.5389 26.9794L27.8818 23.8931L29.6049 20.2972C29.6049 20.2972 31.2731 17.2509 32.968 15.4404C32.3392 14.7072 31.6326 14.0083 30.9259 13.5582C29.1856 12.4497 28.6989 13.1616 27.9752 14.2206C27.7283 14.5817 27.4538 14.9833 27.0926 15.3667C25.3889 17.1753 23.6852 20.3402 23.6852 20.3402L21.9815 23.9573L20.6536 27.0618C20.6536 27.0618 19.9521 29.4058 19.7516 30.1872L19 33H42L41.9495 32.8827H24.8666Z",
    fill: "#E2E8F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5556 32.031C36.4074 32.578 36 34 36 34H53C53 34 51.4815 31.0101 51.1111 29.8433C50.7407 28.6765 49.537 26.7206 49.537 26.7206L47.963 23.8722C47.963 23.8722 46.3889 21.3402 44.8148 20.3907C43.0897 19.3502 41.9815 21.6567 41.9815 21.6567L39.463 25.0302L38.2037 27.6701C38.2037 27.6701 37.4444 29.2964 37.2222 29.8433C37.0444 30.2808 36.7037 31.4841 36.5556 32.031Z",
    fill: "white",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3159 32.9296L41.7455 31.2518C41.8601 30.7858 42.2611 29.3876 42.2611 29.3876L43.0202 27.5358L43.9941 25.3783C43.9941 25.3783 44.937 23.5505 45.895 22.4642C45.5395 22.0243 45.1401 21.605 44.7407 21.3349C43.7571 20.6698 43.482 21.097 43.0729 21.7323C42.9334 21.949 42.7782 22.19 42.5741 22.42C41.6111 23.5052 40.6481 25.4041 40.6481 25.4041L39.6852 27.5744L38.9346 29.4371C38.9346 29.4371 38.5381 30.8435 38.4248 31.3123L38 33H51L50.9715 32.9296H41.3159Z",
    fill: "#E2E8F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyProject);
export default __webpack_public_path__ + "static/media/icon_empty_project.c7c3f3b30e84aefa31c76e2ca38b4a7b.svg";
export { ForwardRef as ReactComponent };